module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAoklEQVRIS+2WwQ2AIAxFK1PoNKQLuIYzuYYLNEyjU6DxoDFG/FIPvdRr/Tz4/NA2ZPQ1RlwqglNKfc55JKJWubklhDDEGKcnfREsIvMP6MFamLmrBa+7gJlV1yEir/q3Ezu4KmNu9d0uD9fpCAoHShrSu9VutV2TQOlF9VJ3g6lGC6O6Guz9GFl71P3lqmmLNlOm2Vz9NUTa/1QzsxZ21ZmBN5qivB8lu/TjAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/image/login_icon_phone_forget.png
// module id = 999
// module chunks = 30